import axios from './axios';

export default class ContentNetworkLayer {
  static async createSubject(data) {
    const response = await axios.post('api/misc/submit-subject', data);
    return response.data;
  }

  static async createSubTopic(data) {
    const response = await axios.post('api/misc/submit-subtopic', data);
    return response.data;
  }

  static async createTopic(data) {
    const response = await axios.post('api/misc/submit-topic', data);
    return response.data;
  }

  static async createNotes(data) {
    const response = await axios.post('api/misc/submit-notes', data);
    return response.data;
  }

  static async getSubjects() {
    const response = await axios.get('api/misc/subjects');
    return response.data;
  }

  static async getTopics() {
    const response = await axios.get('api/misc/topics');
    return response.data;
  }

  static async getSubTopics() {
    const response = await axios.get('api/misc/subtopics');
    return response.data;
  }

  static async createQuestion(data) {
    const response = await axios.post('api/misc/create-question', data);
    return response.data;
  }

  static async getNotesBySubtopic(subtopicId) {
    const response = await axios.get(`api/misc/notes-by-subtopic/${subtopicId}`);
    return response.data;
  }

  static async updateNote(noteId, data) {
    const response = await axios.put(`api/misc/notes/${noteId}`, data);
    return response.data;
  }

  // ── Delete operations ───────────────────────────────────────────────────

  static async deleteNote(noteId) {
    const response = await axios.delete(`api/misc/notes/${noteId}`);
    return response.data;
  }

  static async deleteQuestion(questionId) {
    const response = await axios.delete(`api/misc/questions/${questionId}`);
    return response.data;
  }

  static async deleteSubject(code) {
    const response = await axios.delete(`api/misc/subjects/${code}`);
    return response.data;
  }

  static async deleteTopic(topicId) {
    const response = await axios.delete(`api/misc/topics/${topicId}`);
    return response.data;
  }

  static async deleteSubTopic(subTopicId) {
    const response = await axios.delete(`api/misc/subtopics/${subTopicId}`);
    return response.data;
  }

  // ── Reorder operations ─────────────────────────────────────────────────

  static async moveTopic(topicId, direction) {
    const response = await axios.post(`api/misc/topics/${topicId}/move`, { direction });
    return response.data;
  }

  static async moveSubtopic(subTopicId, direction) {
    const response = await axios.post(`api/misc/subtopics/${subTopicId}/move`, { direction });
    return response.data;
  }

  static async getQuestions() {
    const response = await axios.get('api/misc/get-questions');
    return response.data;
  }

  static async updateQuestion(questionId, data) {
    const response = await axios.put(`api/misc/questions/${questionId}`, data);
    return response.data;
  }

  static async getQuestionsByCode(code) {
    const response = await axios.get(`api/misc/get-questions-by-topic-code?code=${code}`);
    return response.data;
  }

  // ── Topic Questions ────────────────────────────────────────────────────

  static async createTopicQuestion(data) {
    const response = await axios.post('api/misc/create-topic-question', data);
    return response.data;
  }

  static async getTopicQuestions(topicId) {
    const response = await axios.get(`api/misc/topic-questions/${topicId}`);
    return response.data;
  }

  static async deleteTopicQuestion(questionId) {
    const response = await axios.delete(`api/misc/topic-questions/${questionId}`);
    return response.data;
  }

  // ── Subtopic Questions ────────────────────────────────────────────────────

  static async createSubtopicQuestion(data) {
    const response = await axios.post('api/misc/create-subtopic-question', data);
    return response.data;
  }

  static async getSubtopicQuestions(subtopicId) {
    const response = await axios.get(`api/misc/subtopic-questions/${subtopicId}`);
    return response.data;
  }

  static async deleteSubtopicQuestion(questionId) {
    const response = await axios.delete(`api/misc/questions/${questionId}`);
    return response.data;
  }
}
